import styled from 'styled-components/macro';

export const BoxViewerWrapper = styled.div`
  /* border: red solid 1px; */
  display: flex;
`;
export const ResizeableBox = styled.div`
  border-radius: 0;
  /* min-height: 400px; */
  background-color: #fff;
  padding-right: 2rem;
  max-width: 100%;
`;
export const ResizeableBoxHandle = styled.div`
  background-color: var(--coolGray-800);
  display: flex;
  align-items: center;
  cursor: col-resize;
  transform: none !important;
  border-radius: 3px;
`;
export const CustomSizeWrapper = styled.div`
  display: flex;
  margin-top: 0.5rem;
  align-items: center;
  button {
    appearance: button;
    cursor: pointer;
    background: none;
    border: none;
    padding: 3px;
    border-radius: 3px;
    transition: background-color 200ms ease;
    &:hover {
      background-color: var(--indigo-100);
      color: var(--color-primary);
    }
  }
  p {
    margin-left: 0.5rem;
  }
`;
